import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizChooseItem } from "~/modules/QuizChooseItem";

const Theme36Task1 = () => {
  const items: { name: string }[] = [
    {
      name: "20 июня"
    },
    {
      name: "22 августа"
    },
    {
      name: "22 июня"
    },
    { name: "12 июля" }
  ];
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Когда началась Великая Отечественная война? '
      description='Выбери правильный ответ'
      successIcon='rus-1'
    >
      <QuizChooseItem type='str' items={items} correctItem='22 июня' />
    </QuizWrapper>
  );
};

export default Theme36Task1;
